export const getObjectValuesAsString = (obj: any) => {
  const values = Object.values(obj);
  return values.join(', ');
};

export const isObject = (value: any) => {
  return value && typeof value === 'object' && value.constructor === Object;
};
